import { Button, Stack } from '@mui/material'
import { UICarePostArticleImg, UITaskPostArticleImg } from 'features/UI'
import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import { ArticleType, CareArticleType, ShareTimelineItem } from 'types'
import { getRoute } from 'utils'
import { TimelineItemCard } from '../../../Timeline/components/TimelineItemCard/TimelineItemCard'
import { TimelineLine } from '../../../Timeline/components/TimelineLine/TimelineLine'

export function SharedCareArticleItem({
  item,
  commentControl,
}: {
  item: ShareTimelineItem
  commentControl?: ReactNode
}) {
  const navigate = useNavigate()

  const onClickArticle = () => {
    const route = getRoute(routes.sharedItem, {
      sharedItemType: ArticleType.CareArticle,
      sharedItemId: item.id,
    })
    navigate(route)
  }

  if (!item.careArticle) {
    return null
  }

  return (
    <Stack direction="row" spacing={2}>
      <div style={{ position: 'relative', minWidth: 30, minHeight: '100%' }}>
        {item.careArticle.type === CareArticleType.Care && <UICarePostArticleImg isOnTimeline />}
        {item.careArticle.type === CareArticleType.Task && <UITaskPostArticleImg />}
        <TimelineLine />
      </div>

      <TimelineItemCard
        title={item.careArticle.post || item.careArticle.name}
        bannerUrl={item.careArticle.bannerUrl}
        status={item.status}
        readingTime={item.careArticle.silentReadingTime}
        commentControl={commentControl}
        onClick={onClickArticle}
        controls={
          <Button size="small" variant="contained" onClick={onClickArticle}>
            View
          </Button>
        }
      />
    </Stack>
  )
}
